/**
 * Testimonial Slider Js
 */

var bsSlider = function (elem) {
  var tablists = document.querySelectorAll('.testimonials-cite[role="tablist"]'),
    currentSlide = 0,
    tabs = elem.querySelectorAll('.slider-thumbs-div[role="tab"]'),
    panels = elem.querySelectorAll('.bs-slider-gallery--list[role="tabpanel"]');

  // For easy reference
  var keys = {
    end: 35,
    home: 36,
    left: 37,
    up: 38,
    right: 39,
    down: 40,
    delete: 46,
    enter: 13,
    space: 32,
  };

  // Add or subtract depending on key pressed
  var direction = {
    37: -1,
    38: -1,
    39: 1,
    40: 1,
  };

  // Remove tabindex attribute
  tabs[0].removeAttribute('tabindex');

  // Set the tab as selected
  tabs[0].setAttribute('aria-selected', 'true');

  //set active to element
  tabs[0].parentElement.classList.add('active');

  panels[0].removeAttribute('hidden');
  panels[0].classList.add('active');
  panels[0].classList.remove('hide');

  // Bind listeners
  for (i = 0; i < tabs.length; ++i) {
    addListeners(i);
  }

  function addListeners(index) {
    tabs[index].addEventListener('click', clickEventListener);
    tabs[index].addEventListener('keydown', keydownEventListener);
    tabs[index].addEventListener('keyup', keyupEventListener);

    // Build an array with all tabs (<button>s) in it
    tabs[index].index = index;
  }

  // When a tab is clicked, activateTab is fired to activate it
  function clickEventListener(event) {
    var tab = event.target;
    activateTab(tab, true);
  }

  // Handle keydown on tabs
  function keydownEventListener(event) {
    var key = event.keyCode;

    switch (key) {
      case keys.end:
        event.preventDefault();
        // Activate last tab
        focusLastTab();
        break;
      case keys.home:
        event.preventDefault();
        // Activate first tab
        focusFirstTab();
        break;

      // Up and down are in keydown
      // because we need to prevent page scroll >:)
      case keys.up:
      case keys.down:
        determineOrientation(event);
        break;
    }
  }

  // Handle keyup on tabs
  function keyupEventListener(event) {
    var key = event.keyCode;

    switch (key) {
      case keys.left:
      case keys.right:
        determineOrientation(event);
        break;
      case keys.delete:
        determineDeletable(event);
        break;
      case keys.enter:
      case keys.space:
        activateTab(event.target);
        break;
    }
  }

  /**
   * prev/next clicked on mobile
   */
  if (elem) {
    var prevNav = elem.querySelector('.prev'),
      nextNav = elem.querySelector('.next');

    prevNav.addEventListener('click', function (e) {
      if (currentSlide === 0) {
        currentSlide = panels.length - 1;
      } else {
        currentSlide--;
      }

      activateTab(tabs[currentSlide]);

      e.preventDefault();
    });

    nextNav.addEventListener('click', function (e) {
      if (currentSlide === panels.length - 1) {
        currentSlide = 0;
      } else {
        currentSlide++;
      }

      activateTab(tabs[currentSlide]);

      e.preventDefault();
    });
  }

  // When a tablist's aria-orientation is set to vertical,
  // only up and down arrow should function.
  // In all other cases only left and right arrow function.
  function determineOrientation(event) {
    var key = event.keyCode,
      proceed = false;

    tablists.forEach(function(tablist) {
      var vertical = tablist.getAttribute('aria-orientation') === 'vertical';

      if (vertical) {
        if (key === keys.up || key === keys.down) {
          event.preventDefault();
          proceed = true;
        }
      } else {
        if (key === keys.left || key === keys.right) {
          proceed = true;
        }
      }
    });

    if (proceed) {
      switchTabOnArrowPress(event);
    }
  }

  // Either focus the next, previous, first, or last tab
  // depending on key pressed
  function switchTabOnArrowPress(event) {
    var pressed = event.keyCode;

    if (direction[pressed]) {
      var target = event.target;
      if (target.index !== undefined) {
        if (tabs[target.index + direction[pressed]]) {
          tabs[target.index + direction[pressed]].focus();
        } else if (pressed === keys.left || pressed === keys.up) {
          focusLastTab();
        } else if (pressed === keys.right || pressed == keys.down) {
          focusFirstTab();
        }
      }
    }
  }

  // Activates any given tab panel
  function activateTab(tab, setFocus) {
    setFocus = setFocus || false;

    // Deactivate all other tabs
    deactivateTabs();

    // Remove tabindex attribute
    tab.removeAttribute('tabindex');

    // Set the tab as selected
    tab.setAttribute('aria-selected', 'true');

    //set active to element
    tab.parentElement.classList.add('active');

    // Get the value of aria-controls (which is an ID)
    var controls = tab.getAttribute('aria-controls');

    // Remove hidden attribute from tab panel to make it visible
    var controlDom = document.getElementById(controls);
    if (controlDom) {
      controlDom.removeAttribute('hidden');
      controlDom.classList.remove('hide');
    }

    //Testimonial background image
    var backgroundURL = tab.parentElement.getAttribute('data-background'),
      backgroundRetinaURL = tab.parentElement.getAttribute('data-background2x'),
      testmonialBody = document.getElementById('testimonials-body');

    if (isRetina() && backgroundRetinaURL) {
      testmonialBody.style.backgroundImage = 'url("' + backgroundRetinaURL + '")';
    } else if (backgroundURL) {
      testmonialBody.style.backgroundImage = 'url("' + backgroundURL + '")';
    } else {
      testmonialBody.style.backgroundImage = "none";
    }

    // Set focus when required
    if (setFocus) {
      tab.focus();
    }

    //show images from lazy load
    lazyLoading.show();
  }

  // Deactivate all tabs and tab panels
  function deactivateTabs() {
    for (t = 0; t < tabs.length; t++) {
      tabs[t].setAttribute('tabindex', '-1');
      tabs[t].setAttribute('aria-selected', 'false');
      tabs[t].parentElement.classList.remove('active');
    }

    for (p = 0; p < panels.length; p++) {
      panels[p].setAttribute('hidden', 'hidden');
      panels[p].classList.add('hide');
    }
  }

  // Make a guess
  function focusFirstTab() {
    tabs[0].focus();
  }

  // Make a guess
  function focusLastTab() {
    tabs[tabs.length - 1].focus();
  }

  // Detect if a tab is deletable
  function determineDeletable(event) {
    target = event.target;

    if (target.getAttribute('data-deletable') !== null) {
      // Delete target tab
      deleteTab(event, target);

      // Activate the closest tab to the one that was just deleted
      if (target.index - 1 < 0) {
        activateTab(tabs[0]);
      } else {
        activateTab(tabs[target.index - 1]);
      }
    }
  }

  // Deletes a tab and its panel
  function deleteTab(event) {
    var target = event.target;
    var panel = document.getElementById(target.getAttribute('aria-controls'));

    target.parentElement.removeChild(target);
    panel.parentElement.removeChild(panel);
  }

  function isRetina() {
    if (window.matchMedia) {
      var mq = window.matchMedia(
        'only screen and (min--moz-device-pixel-ratio: 1.3), only screen and (-o-min-device-pixel-ratio: 2.6/2), only screen and (-webkit-min-device-pixel-ratio: 1.3), only screen  and (min-device-pixel-ratio: 1.3), only screen and (min-resolution: 1.3dppx)'
      );
      return (mq && mq.matches) || window.devicePixelRatio > 1;
    }
  }
};
